<template>
  <div id="column">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name:'column'
}
</script>




// WEBPACK FOOTER //
// src/views/portal/setup/column/column.vue